// import { defaultDefaultCountry } from "./config";

import { defaultDefaultCountry } from "./config";

export const getStandardCountryList = (t: (key: string) => string) => {
  // Translation function
  // const t = (text: string) => text;

  const natcasesortObject = (obj: any) => {
    // Convert the object to an array of key-value pairs
    const entries = Object.entries(obj);

    // Sort the array using Intl.Collator
    entries.sort((a, b) => new Intl.Collator(undefined, { numeric: true, sensitivity: "base" }).compare(a[1] as string, b[1] as string));

    // Convert the sorted array back to an object
    return Object.fromEntries(entries);
  };

  const countries = {
    AC: t("countries.AC"),
    AD: t("countries.AD"),
    AE: t("countries.AE"),
    AF: t("countries.AF"),
    AG: t("countries.AG"),
    AI: t("countries.AI"),
    AL: t("countries.AL"),
    AM: t("countries.AM"),
    AN: t("countries.AN"),
    AO: t("countries.AO"),
    AQ: t("countries.AQ"),
    AR: t("countries.AR"),
    AS: t("countries.AS"),
    AT: t("countries.AT"),
    AU: t("countries.AU"),
    AW: t("countries.AW"),
    AX: t("countries.AX"),
    AZ: t("countries.AZ"),
    BA: t("countries.BA"),
    BB: t("countries.BB"),
    BD: t("countries.BD"),
    BE: t("countries.BE"),
    BF: t("countries.BF"),
    BG: t("countries.BG"),
    BH: t("countries.BH"),
    BI: t("countries.BI"),
    BJ: t("countries.BJ"),
    BL: t("countries.BL"),
    BM: t("countries.BM"),
    BN: t("countries.BN"),
    BO: t("countries.BO"),
    BQ: t("countries.BQ"),
    BR: t("countries.BR"),
    BS: t("countries.BS"),
    BT: t("countries.BT"),
    BV: t("countries.BV"),
    BW: t("countries.BW"),
    BY: t("countries.BY"),
    BZ: t("countries.BZ"),
    CA: t("countries.CA"),
    CC: t("countries.CC"),
    CD: t("countries.CD"),
    CF: t("countries.CF"),
    CG: t("countries.CG"),
    CH: t("countries.CH"),
    CI: t("countries.CI"),
    CK: t("countries.CK"),
    CL: t("countries.CL"),
    CM: t("countries.CM"),
    CN: t("countries.CN"),
    CO: t("countries.CO"),
    CP: t("countries.CP"),
    CR: t("countries.CR"),
    CU: t("countries.CU"),
    CV: t("countries.CV"),
    CW: t("countries.CW"),
    CX: t("countries.CX"),
    CY: t("countries.CY"),
    CZ: t("countries.CZ"),
    DE: t("countries.DE"),
    DG: t("countries.DG"),
    DJ: t("countries.DJ"),
    DK: t("countries.DK"),
    DM: t("countries.DM"),
    DO: t("countries.DO"),
    DZ: t("countries.DZ"),
    EA: t("countries.EA"),
    EC: t("countries.EC"),
    EE: t("countries.EE"),
    EG: t("countries.EG"),
    EH: t("countries.EH"),
    ER: t("countries.ER"),
    ES: t("countries.ES"),
    ET: t("countries.ET"),
    FI: t("countries.FI"),
    FJ: t("countries.FJ"),
    FK: t("countries.FK"),
    FM: t("countries.FM"),
    FO: t("countries.FO"),
    FR: t("countries.FR"),
    GA: t("countries.GA"),
    GB: t("countries.GB"),
    GD: t("countries.GD"),
    GE: t("countries.GE"),
    GF: t("countries.GF"),
    GG: t("countries.GG"),
    GH: t("countries.GH"),
    GI: t("countries.GI"),
    GL: t("countries.GL"),
    GM: t("countries.GM"),
    GN: t("countries.GN"),
    GP: t("countries.GP"),
    GQ: t("countries.GQ"),
    GR: t("countries.GR"),
    GS: t("countries.GS"),
    GT: t("countries.GT"),
    GU: t("countries.GU"),
    GW: t("countries.GW"),
    GY: t("countries.GY"),
    HK: t("countries.HK"),
    HM: t("countries.HM"),
    HN: t("countries.HN"),
    HR: t("countries.HR"),
    HT: t("countries.HT"),
    HU: t("countries.HU"),
    IC: t("countries.IC"),
    ID: t("countries.ID"),
    IE: t("countries.IE"),
    IL: t("countries.IL"),
    IM: t("countries.IM"),
    IN: t("countries.IN"),
    IO: t("countries.IO"),
    IQ: t("countries.IQ"),
    IR: t("countries.IR"),
    IS: t("countries.IS"),
    IT: t("countries.IT"),
    JE: t("countries.JE"),
    JM: t("countries.JM"),
    JO: t("countries.JO"),
    JP: t("countries.JP"),
    KE: t("countries.KE"),
    KG: t("countries.KG"),
    KH: t("countries.KH"),
    KI: t("countries.KI"),
    KM: t("countries.KM"),
    KN: t("countries.KN"),
    KP: t("countries.KP"),
    KR: t("countries.KR"),
    KW: t("countries.KW"),
    KY: t("countries.KY"),
    KZ: t("countries.KZ"),
    LA: t("countries.LA"),
    LB: t("countries.LB"),
    LC: t("countries.LC"),
    LI: t("countries.LI"),
    LK: t("countries.LK"),
    LR: t("countries.LR"),
    LS: t("countries.LS"),
    LT: t("countries.LT"),
    LU: t("countries.LU"),
    LV: t("countries.LV"),
    LY: t("countries.LY"),
    MA: t("countries.MA"),
    MC: t("countries.MC"),
    MD: t("countries.MD"),
    ME: t("countries.ME"),
    MF: t("countries.MF"),
    MG: t("countries.MG"),
    MH: t("countries.MH"),
    MK: t("countries.MK"),
    ML: t("countries.ML"),
    MM: t("countries.MM"),
    MN: t("countries.MN"),
    MO: t("countries.MO"),
    MP: t("countries.MP"),
    MQ: t("countries.MQ"),
    MR: t("countries.MR"),
    MS: t("countries.MS"),
    MT: t("countries.MT"),
    MU: t("countries.MU"),
    MV: t("countries.MV"),
    MW: t("countries.MW"),
    MX: t("countries.MX"),
    MY: t("countries.MY"),
    MZ: t("countries.MZ"),
    NA: t("countries.NA"),
    NC: t("countries.NC"),
    NE: t("countries.NE"),
    NF: t("countries.NF"),
    NG: t("countries.NG"),
    NI: t("countries.NI"),
    NL: t("countries.NL"),
    NO: t("countries.NO"),
    NP: t("countries.NP"),
    NR: t("countries.NR"),
    NU: t("countries.NU"),
    NZ: t("countries.NZ"),
    OM: t("countries.OM"),
    PA: t("countries.PA"),
    PE: t("countries.PE"),
    PF: t("countries.PF"),
    PG: t("countries.PG"),
    PH: t("countries.PH"),
    PK: t("countries.PK"),
    PL: t("countries.PL"),
    PM: t("countries.PM"),
    PN: t("countries.PN"),
    PR: t("countries.PR"),
    PS: t("countries.PS"),
    PT: t("countries.PT"),
    PW: t("countries.PW"),
    PY: t("countries.PY"),
    QA: t("countries.QA"),
    QO: t("countries.QO"),
    RE: t("countries.RE"),
    RO: t("countries.RO"),
    RS: t("countries.RS"),
    RU: t("countries.RU"),
    RW: t("countries.RW"),
    SA: t("countries.SA"),
    SB: t("countries.SB"),
    SC: t("countries.SC"),
    SD: t("countries.SD"),
    SE: t("countries.SE"),
    SG: t("countries.SG"),
    SH: t("countries.SH"),
    SI: t("countries.SI"),
    SJ: t("countries.SJ"),
    SK: t("countries.SK"),
    SL: t("countries.SL"),
    SM: t("countries.SM"),
    SN: t("countries.SN"),
    SO: t("countries.SO"),
    SR: t("countries.SR"),
    SS: t("countries.SS"),
    ST: t("countries.ST"),
    SV: t("countries.SV"),
    SX: t("countries.SX"),
    SY: t("countries.SY"),
    SZ: t("countries.SZ"),
    TA: t("countries.TA"),
    TC: t("countries.TC"),
    TD: t("countries.TD"),
    TF: t("countries.TF"),
    TG: t("countries.TG"),
    TH: t("countries.TH"),
    TJ: t("countries.TJ"),
    TK: t("countries.TK"),
    TL: t("countries.TL"),
    TM: t("countries.TM"),
    TN: t("countries.TN"),
    TO: t("countries.TO"),
    TR: t("countries.TR"),
    TT: t("countries.TT"),
    TV: t("countries.TV"),
    TW: t("countries.TW"),
    TZ: t("countries.TZ"),
    UA: t("countries.UA"),
    UG: t("countries.UG"),
    UM: t("countries.UM"),
    US: t("countries.US"),
    UY: t("countries.UY"),
    UZ: t("countries.UZ"),
    VA: t("countries.VA"),
    VC: t("countries.VC"),
    VE: t("countries.VE"),
    VG: t("countries.VG"),
    VI: t("countries.VI"),
    VN: t("countries.VN"),
    VU: t("countries.VU"),
    WF: t("countries.WF"),
    WS: t("countries.WS"),
    XK: t("countries.XK"),
    YE: t("countries.YE"),
    YT: t("countries.YT"),
    ZA: t("countries.ZA"),
    ZM: t("countries.ZM"),
    ZW: t("countries.ZW"),
  };

  const newCountries = natcasesortObject(countries);
  return newCountries;
};

// Example usage
// export const COUNTRIES = getStandardCountryList();
export const WAITLIST = -1;

export const formatPhone = (phone: string | null, country: null | string = null, returnInvalidNumbers = true) => {
  if (!phone) {
    return "";
  }
  // Take default country if not provided
  if (!country) {
    country = defaultDefaultCountry;
  }

  // Replace (0) with empty string
  phone = phone.replace(/\(0\)/g, "");

  // Sanitize phone number to only keep digits
  // phone = phone.replace(/\D/g, "");
  phone = phone.replace(/(?!^\+)\D/g, "");

  // Additional replacements
  phone = phone.replace(/\./g, "").replace(/-/g, "");

  if (!phone) {
    return "";
  }

  let prefix = "";

  // Check if phone is an international number
  if (validatePhone(phone, false, country)) {
    // Convert leading 00 to +
    phone = phone.replace(/^00/, "+");
    return phone;
  }

  // Validate local numbers if a country is provided
  if (country && validatePhone(phone, false, country)) {
    if (!country) {
      return "";
    }

    // Determine prefix based on country code
    switch (country) {
      case "DE":
        prefix = "49";
        break;
      case "NL":
        prefix = "31";
        break;
      case "AT":
        prefix = "43";
        break;
      case "HU":
        prefix = "36";
        break;
      case "LI":
        prefix = "423";
        break;
      default:
        prefix = "41";
    }

    // Remove starting zero and add prefix
    if (phone.startsWith("0")) {
      phone = `+${prefix}${phone.substring(1)}`;
    } else {
      phone = `+${prefix}${phone}`;
    }

    return phone;
  }

  // If phone number is neither local nor international
  if (returnInvalidNumbers) {
    return phone;
  }

  return "";
};

// Function to validate phone numbers
export const validatePhone = (value: string, internationalNumber = true, country: string | null = null) => {
  // Allow spaces, hyphens, +41, 0041, +41(0)79
  value = value.replace("(0)", "");
  value = value.replace(/\D/g, "");

  // Regular expression for international numbers
  const regexInt = /^(\+|00)?([1-9][0-9]{1,2})\s?-?(\(0\))?\s?([1-9][0-9])\s?-?(\d{3})\s?-?(\d{2})\s?-?(\d{2})/; // chatgpt
  // const regexInt = /^((\+|00)?)([1-9][0-9]{1,2})(\s?)(\-?)((\(0\))?)(\s?)([1-9][0-9])(\s?)(\-?)(\d{3})(\s?)(\-?)(\d{2})(\s?)(\-?)(\d{2})/;
  let matches = false;
  let matches2 = false;

  // Check international numbers
  if (internationalNumber) {
    matches = regexInt.test(value);
  }

  // Numbers without country prefix
  if (!country) {
    // Take default country if not provided
    if (!country) {
      country = defaultDefaultCountry;
    }

    let regexLocal;
    switch (country) {
      case "DE":
        // regexLocal = /^(((((((00|\+)49[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/;
        regexLocal = /^\+(?:[0-9] ?){8,14}[0-9]$/;
        break;
      case "LI":
        regexLocal = /^\+(?:[0-9] ?){8,14}[0-9]$/;
        break;
      case "CH":
      default:
        regexLocal = /^(\+|00)?([1-9][0-9]{1,2})\s?-?(\(0\))?\s?([1-9][0-9])\s?-?(\d{3})\s?-?(\d{2})\s?-?(\d{2})/;
        // regexLocal = /^((\+|00)?)([1-9][0-9]{1,2})(\s?)(\-?)((\(0\))?)(\s?)([1-9][0-9])(\s?)(\-?)(\d{3})(\s?)(\-?)(\d{2})(\s?)(\-?)(\d{2})/;
        // regexLocal = /^((\(0\)|0))(\s?)([1-9][0-9]{1,4})(\s?)(\-?)(\d{3})(\s?)(\-?)(\d{2})(\s?)(\-?)(\d{2})/;
        // regexLocal = /^(((((((00|\+)49[ \-/]?)|0)[1-9][0-9]{1,4})[ \-/]?)|((((00|\+)49\()|\(0)[1-9][0-9]{1,4}\)[ \-/]?))[0-9]{1,7}([ \-/]?[0-9]{1,5})?)$/;
        break;
    }
    matches2 = regexLocal.test(value);
  }

  return matches || matches2;
};

// Function to extract ID from extended ID
export const extractIdFromExtendedId = (extendedId: string): number => {
  // If it is not an extended ID, then just return it.
  if (!extendedId.includes("_")) {
    return parseInt(extendedId);
  }

  // Ensure extendedId has more than 2 characters
  if (extendedId.length <= 2) {
    throw new Error("Invalid extended ID length.");
  }

  const parts = extendedId.split("_");

  // Ensure there are exactly 2 parts
  if (parts.length !== 2) {
    throw new Error("Invalid extended ID format.");
  }

  // Process values
  // const schema = parts[0];
  return parseInt(parts[1]); // Return ID
};
